import axios from 'axios';

const apiBaseURL = window.APP_CONFIG.API_BASE_URL;

//创建Axios 实例
const apiClient = axios.create({
    baseURL: `${apiBaseURL}/api`,
    timeout: 5000,
});

//登陆
export const login = (data)=>{
    return apiClient.post(`/v1/auth/login`,data);
};

//获取安全问题
export const fetchSecurityQuestion = (username)=>{
    return apiClient.get(`/login/securityQuestion/${username}`)
}

//验证安全问题的答案
export const verifyAnswer = (data)=>{
    return apiClient.post(`/login/verifySecurityAnswer`,data)
}

//重置密码
export const resetPassword = (user)=>{
    return apiClient.post(`/login/resetPassword`,user)
}

//新增响应拦截器，统一处理4xxx报错，因为anxios可能自己处理，无法传递到业务层的catch中
apiClient.interceptors.response.use(
    (response)=>response, //正常响应直接返回
    (error) =>{
        return Promise.reject(error); //网络错误或无响应，传递给业务层处理。
    }
)